import type { InjectionKey } from 'vue'

export interface ChartContext {
  meta: {
    xAxis: PropertyKey
    labels?: { x?: string }
  }
  data: {
    onHover: (values: { y: object }) => void
  }
  attr: {
    colors: string[]
  }
}

export const chartContextKey: InjectionKey<ChartContext> = Symbol('chart-context')
